import type { AuthState } from 'types';

export enum STORE_KEYS {
  loginCode = 'loginCode',
  AUTH = 'auth',
  STAY_LOGGED_IN = 'stayLoggedIn',
  POST_LOGIN_REDIRECT = 'postLoginRedirect',
  IS_IMPERSONATING = 'isImpersonating',
  IS_SUBSTITUTING = 'isSubstituting',
  OIDC_STATE = 'oidcState',
  OIDC_NONCE = 'oidcNonce',
  OIDC_CODE_VERIFIER = 'oidcCodeVerifier',
  OIDC_RETURN_PATH = 'oidcReturnPath',
  LOGIN_ERROR = 'loginError',
}

export type PostLoginRedirect = {
  path: string;
  createdAt: number;
};

export type STORE_VALUES = {
  [STORE_KEYS.loginCode]: string;
  [STORE_KEYS.AUTH]: AuthState;
  [STORE_KEYS.STAY_LOGGED_IN]: boolean;
  [STORE_KEYS.POST_LOGIN_REDIRECT]: PostLoginRedirect;
  [STORE_KEYS.IS_IMPERSONATING]: boolean;
  [STORE_KEYS.IS_SUBSTITUTING]: boolean;
  [STORE_KEYS.OIDC_STATE]: string;
  [STORE_KEYS.OIDC_NONCE]: string;
  [STORE_KEYS.OIDC_CODE_VERIFIER]: string;
  [STORE_KEYS.OIDC_RETURN_PATH]: string;
  [STORE_KEYS.LOGIN_ERROR]: string;
};
